import { toCents } from '@/utils/format.utils';
import dayjs from 'dayjs';
import { PaymentServiceApiFactory, type ModelOfflinePaymentRequest, type ModelPaymentResponse } from '@layup/api-sdk';
import type { IPayment, IPaymentRedirectResponse, PaymentParams } from '../models/payments';
import { createLayupClient } from './layupApi';

export const paymentServiceClient = () => {
  const client = createLayupClient(false);
  return PaymentServiceApiFactory(undefined, undefined, client);
};

export async function createPayment(
  paymentPlanId: string,
  amount: number,
  notificationUrl: string,
  paymentMethod?: string,
  isEmbeddedCheckout = false,
  destinationType?: string,
): Promise<IPaymentRedirectResponse> {
  const client = createLayupClient(false);
  const paymentRequest = {
    checkout: true,
    paymentPlanId,
    amount: toCents(amount),
    notifyUrl: notificationUrl,
    paymentMethod,
    isEmbeddedCheckout,
    destinationType,
  };
  const response = await client.post('/v1/payments', paymentRequest);
  return response.data;
}

export const getPayment = async (
  id: string,
  isEmbeddedCheckout = false,
  registrationId?: string,
): Promise<IPayment> => {
  const client = createLayupClient();
  let url = `/v1/payments/${id}`;
  if (isEmbeddedCheckout && registrationId) {
    url = url.concat(`?isEmbeddedCheckout=${isEmbeddedCheckout}&registrationId=${registrationId}`);
  } else if (isEmbeddedCheckout) {
    url = url.concat(`?isEmbeddedCheckout=${isEmbeddedCheckout}`);
  } else if (registrationId) {
    url = url.concat(`?registrationId=${registrationId}`);
  }
  const response = await client.get(url, {
    params: {
      verify: true,
    },
  });
  return response.data;
};

export const createEftPayment = async (paymentRequest: any): Promise<IPaymentRedirectResponse> => {
  const client = createLayupClient(false);
  const { data } = await client.post(`/v1/payments/`, paymentRequest);
  return data;
};

export const createDirectPayment = async (
  paymentRequest: ModelOfflinePaymentRequest,
): Promise<ModelPaymentResponse> => {
  const { data } = await paymentServiceClient().paymentServiceCreateOffline({
    modelOfflinePaymentRequest: paymentRequest,
  });
  return data;
};

export const fetchPayments = async (params: PaymentParams): Promise<any> => {
  const client = createLayupClient(false);

  if (params.state === 'MISSED') {
    params.state = 'false';
    params.to = dayjs().toDate();
  }

  if (params.state === 'FAILED') {
    params.state = null;
    params.failed = true;
  }

  if (params.state === 'SETTLED') {
    params.state = null;
    params.settled = 'SETTLED';
  }

  const response = await client.get('v1/payments-report', {
    params: {
      limit: params.limit,
      paid: params.state,
      toDatePayments: params.to,
      fromDatePayments: params.from,
      type: params.type,
      search: params.search,
      settled: params.settled,
      failed: params.failed,
      sort: params.sort,
      skip: params.skip,
      method: params.method,
      provider: params.provider,
    },
  });

  return response.data;
};
